import lowerCase from "lodash/lowerCase";

const smartTrim = (str) => {
  return str.replace(/\s+/g, " ").trim();
};

export const normalizeText = (str) => {
  return lowerCase(smartTrim(str));
};
